import { config, dom, library } from '@fortawesome/fontawesome-svg-core';

import customAllegro from './icons/allegro.svg';
import customCamera from './icons/camera.svg';
import customHeart from './icons/heart.svg';
// import customLearnRead from './icons/learn-read.svg';
import customReturn from './icons/return.svg';
import customSpeechBubble from './icons/speech-bubble.svg';
import customThumbDown from './icons/thumb-down.svg';
import customThumbUp from './icons/thumb-up.svg';

import {
    faClock as faClockRegular,
    faChevronDown as faChevronDownRegular,
    faChevronLeft as faChevronLeftRegular,
    faChevronRight as faChevronRightRegular,
    faClockOneThirty as faClockOneThirtyRegular,
    faEnvelope as faEnvelopeRegular,
    faSearch as faSearchRegular,
    faTrophyStar as faTrophyStarRegular,
} from '@fortawesome/pro-regular-svg-icons';

import {
    faBookOpenReader as faBookOpenReaderLight,
    faCalendar as faCalendarLight,
    faGlobe as faGlobeLight,
    faLocationDot as faLocationDotLight,
    faPhoneVolume as faPhoneVolumeLight,
    faThumbsDown as faThumbsDownLight,
    faThumbsUp as faThumbsUpLight,
} from '@fortawesome/pro-light-svg-icons';

import {
    faMoon as faMoonSolid,
    faStar as faStarSolid,
    faStarHalf as faStarHalfSolid,
    faSun as faSunSolid,
    faSpinner as faSpinnerSolid
} from '@fortawesome/pro-solid-svg-icons';

import { 
    faCalendarDays as  faCalendarDaysThin,
    faComments as faCommentsThin,
} from '@fortawesome/pro-thin-svg-icons';

import {
    faFacebookF,
    faGoogle,
    faInstagram,
    faXTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';



// Example custom phone icon
// Use it this way: <i class="custom fa-phone"></i>
// import phone from './icons/phone';
// calendar.svg
// camera.svg
// clock.svg
// heart.svg
// speech-bubble.svg
// video-camera.svg



config.searchPseudoElements = true;

library.add(
    faBookOpenReaderLight,
    faCalendarLight,
    faCalendarDaysThin,
    faChevronDownRegular,
    faChevronLeftRegular,
    faChevronRightRegular,
    faClockRegular,
    faClockOneThirtyRegular,
    faCommentsThin,
    faEnvelopeRegular,
    faFacebookF,
    faGoogle,
    faGlobeLight,
    faInstagram,
    faLocationDotLight,
    faMoonSolid,
    faPhoneVolumeLight,
    faSearchRegular,
    faSpinnerSolid,
    faSunSolid,
    faStarSolid,
    faStarHalfSolid,
    faThumbsDownLight,
    faThumbsUpLight,
    faTrophyStarRegular,
    faXTwitter,
    faYoutube,
);

library.add(
    customAllegro,
    customCamera,
    customHeart,
    // customLearnRead,
    customSpeechBubble,
    customReturn,
    customThumbDown,
    customThumbUp,
);

dom.i2svg({node: document.querySelector('.tpl-page-container,.search-form') });

dom.watch({
    autoReplaceSvgRoot:document.querySelector('.tpl-main-content-core,.search-form'),
    observeMutationsRoot:document.querySelector('.tpl-main-content-core,.search-form')
});

export { dom };
